import React from 'react';
import { withRouter } from 'react-router-dom';


class ContactUs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            serviceType: 'Select Service',
            firstName: '',
            lastName: '',
            city: 'Select City',
            email: '',
            landlineNo: '',
            mobileNo: '',
            flatType: null,
            budget: null,
        }
    }
    render() {
        return (
            <section className="section">
                <div className="container">
                    <div className="columns is-centered">
                        <div className="column is-6">
                            <div className="card">
                                <div className="card-content">
                                    <div className="content">
                                        <div className="contact-block">
                                            <div className="title">Call us at</div>
                                            <p className="is-size-5 contact-text">7045655225</p>
                                            <div className="is-size-6">(10 AM to 8PM IST)</div>
                                        </div>
                                        <hr />
                                        <div className="contact-block">
                                            <div className="title">Email us at</div>
                                            <p className="is-size-5 contact-text"><a href="mailto:helpdesk@myhomekart.com">helpdesk@myhomekart.com</a></p>
                                        </div>
                                        <hr />
                                        <div className="contact-block">
                                            <div className="title">Corporate Office</div>
                                            <div className="is-size-6 contact-address">
                                                102/C1, BRAMHA SUNCITY<br />
                                                VADGAONSHERI<br />
                                                KALYANINAGAR ANNEX, <br />
                                                PUNE - 411014
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}
export default withRouter(ContactUs);


// WEBPACK FOOTER //
// ./src/app/routes/contact-us/index.js